import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import TabelaTipoCarga from './Components/TabelaTipoCarga'
import Header from '../components/Header'

const data = [
  { id: 1, rota: 'Carga Fracionada', ativo: true },
  { id: 2, rota: 'Carga Completa', ativo: false },
  { id: 3, rota: 'Carga Perigosa', ativo: true },
  { id: 4, rota: 'Carga Refrigerada', ativo: true },
  { id: 5, rota: 'Carga a Granel', ativo: true },
  { id: 6, rota: 'Carga Conteinerizada', ativo: false },
  { id: 7, rota: 'Carga Especial', ativo: true },
  { id: 8, rota: 'Carga Expresso', ativo: true },
  { id: 9, rota: 'Carga Rodoviária', ativo: false },
  { id: 10, rota: 'Carga Internacional', ativo: true },
];


function TipoCarga() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    

    const headers = [
      { label: 'Selecionar', key: 'checkbox',isVisible: true },
      { label: 'ID', key: 'id', isVisible: true },
      { label: 'Tipo de Carga', key: 'rota', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Tipo de Carga'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaTipoCarga headers={visibleHeaders}  onDelete={handleDelete} dados={data} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default TipoCarga